import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import Distributor from 'models/sales/distributor/Model.Distributor';
import { useProductDocumentProvider } from '../../ProductDocument.Hooks';
import { useProductDealerGroupDocumentProvider } from '../ProductDocument.DealerGroupDocuments.Hooks';

export default function ProductDealerGroupDocumentFilters() {
  const { lang } = getLocales();
  const { productDocument } = useProductDocumentProvider();
  const { dealerGroupDocumentList } = useProductDealerGroupDocumentProvider();

  const distributorsApi = useApi({
    action: Distributor.list,
    wait: true,
    body: {
      productId: productDocument?.productId ? [productDocument.productId] : undefined,
    },
  });

  return (
    <>
      <FilterForm
        subcomponents={ThemeFilterFormDrawer}
        filters={{ distributorId: dealerGroupDocumentList.distributorId } as { distributorId?: number }}
        onFilter={(newFilters) => dealerGroupDocumentList.applyFilters(newFilters)}
        onReset={dealerGroupDocumentList.resetFilters}
        onOpen={() => {
          if (!distributorsApi.payload) distributorsApi.execute((body) => body);
        }}
        render={({ tempFilters, setFilters }) => {
          const distributors = distributorsApi?.payload?.data ?? [];

          return (
            <>
              <SelectInput
                name="distributorId"
                label={lang.distributors}
                data={distributors.map((item) => ({
                  ...item.displayInfo,
                  icon: <Icon class="fas-cloud" />,
                }))}
                isMultiselect={false}
                value={tempFilters?.distributorId}
                disabled={!distributors.length}
                onChange={({ distributorId }) => setFilters({ ...tempFilters, distributorId })}
                icon={<Icon class="fas-cloud" />}
              />
            </>
          );
        }}
      />
    </>
  );
}
